import { onReady } from "@xatom/core";
import { Loader } from "@googlemaps/js-api-loader";
import { initMap } from "./modules/map";

// Initialize Google Maps API
const loader = new Loader({
  apiKey: "AIzaSyCJawWBSKnvVJtCwsnZ40K1-qfCguPgokI",
  version: "weekly",
});

const importAllLibraries = async () => {
  const maps = await loader.importLibrary("maps");
  const marker = await loader.importLibrary("marker");
  const core = await loader.importLibrary("core");
  return { maps, marker, core };
};

// on webflow page is loaded
onReady(() => {
  importAllLibraries()
    .then(({ maps, marker, core }) => {
      console.log("All libraries loaded");
      initMap(maps, marker, core);
    })
    .catch(console.log);
});
